/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Experience_Trendmover_PeriodInputs */

const en_experience_trendmover_period = /** @type {(inputs: Experience_Trendmover_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEC 2022 – MAR 2023`)
};

const ar_experience_trendmover_period = /** @type {(inputs: Experience_Trendmover_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ديسمبر 2022 – مارس 2023`)
};

const bn_experience_trendmover_period = /** @type {(inputs: Experience_Trendmover_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিসে ২০২২ – মার্চ ২০২৩`)
};

const de_experience_trendmover_period = /** @type {(inputs: Experience_Trendmover_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEZ 2022 – MÄRZ 2023`)
};

const es_experience_trendmover_period = /** @type {(inputs: Experience_Trendmover_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DIC 2022 – MAR 2023`)
};

const fr_experience_trendmover_period = /** @type {(inputs: Experience_Trendmover_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DÉC. 2022 – MAR 2023`)
};

const pt_experience_trendmover_period = /** @type {(inputs: Experience_Trendmover_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEZEMBRO DE 2022 – MARÇO DE 2023`)
};

const zh_experience_trendmover_period = /** @type {(inputs: Experience_Trendmover_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2022 年 12 月 – 2023 年 3 月`)
};

const tr_experience_trendmover_period = /** @type {(inputs: Experience_Trendmover_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARALIK 2022 – MAR 2023`)
};

const ru_experience_trendmover_period = /** @type {(inputs: Experience_Trendmover_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ДЕКАБРЬ 2022 ГОДА – МАРТ 2023 ГОДА`)
};

const pl_experience_trendmover_period = /** @type {(inputs: Experience_Trendmover_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRUDZIEŃ 2022 – MAR 2023`)
};

/**
* | output |
* | --- |
* | "DEC 2022 – MAR 2023" |
*
* @param {Experience_Trendmover_PeriodInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const experience_trendmover_period = /** @type {((inputs?: Experience_Trendmover_PeriodInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Experience_Trendmover_PeriodInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_experience_trendmover_period(inputs)
	if (locale === "bn") return bn_experience_trendmover_period(inputs)
	if (locale === "de") return de_experience_trendmover_period(inputs)
	if (locale === "es") return es_experience_trendmover_period(inputs)
	if (locale === "fr") return fr_experience_trendmover_period(inputs)
	if (locale === "pt") return pt_experience_trendmover_period(inputs)
	if (locale === "zh") return zh_experience_trendmover_period(inputs)
	if (locale === "tr") return tr_experience_trendmover_period(inputs)
	if (locale === "ru") return ru_experience_trendmover_period(inputs)
	if (locale === "pl") return pl_experience_trendmover_period(inputs)
	return en_experience_trendmover_period(inputs)
});